import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-af-mutasi-antar-counter',
  templateUrl: './af-mutasi-antar-counter.component.html',
  styleUrls: ['./af-mutasi-antar-counter.component.scss'],
})
export class AfMutasiAntarCounterComponent implements OnInit {

  
    @Input() counterList: any[];
    @Input() counterId: any;
    @Input() counterIdOrigin:any;
  
    @Input() docDateStart: any;
    @Input() docDateEnd: any;
  
    @Input() requestStatus: any;
    statusId:any;
    statusList: any[] = [
      'open', // Request baru dibuat, belum dikirim
      'sent',    // menunggu pengiriman
      'delivery',       // Barang sudah dikirim dari counter asal
      'received',   // Barang diterima di counter tujuan
      'canceled', 
      'reject',
      'revise'
    ];
    selectedCounterDestination: any[];
    selectedCounterOrigin: any[];
  
    constructor(
      public modalController: ModalController
    ) { }
  
    ngOnInit() {
      this.statusId = this.statusList.indexOf(this.requestStatus);
      let selectedCounterOrigin = this.counterList.find(x => x.id ===  this.counterIdOrigin);
      console.log(this.counterIdOrigin);
      console.log(this.counterId);
      console.log(this.counterList)
      let selectedCounterDestination = this.counterList.find(x => x.id ===  this.counterId);
      if(selectedCounterOrigin){
        let idx =this.counterList.indexOf(selectedCounterOrigin);
        this.selectedCounterOrigin=(this.counterList[idx]);
      }
      if(selectedCounterDestination){
        let idx =this.counterList.indexOf(selectedCounterDestination);
        this.selectedCounterDestination=(this.counterList[idx]);
      }  
    }
    async dismissModal(code: any) {
      let dataReturn: any[] = [];
      if(code === 'search') {
        let data = {
          'counter_id': this.counterId,
          'counter_id_origin':this.counterIdOrigin,
          'doc_date_start': this.docDateStart,
          'doc_date_end': this.docDateEnd,
          'request_status': this.statusList[this.statusId]
        };
  
        dataReturn.push(data);
      }
  
      if(code === 'close') {
        dataReturn = [];
      }
      
      await this.modalController.dismiss(dataReturn);
    }
  
    clearField() {
      this.counterId = undefined;
      this.counterIdOrigin = 0;
      this.docDateStart = undefined;
      this.docDateEnd = undefined;
      this.statusId = undefined;
      this.requestStatus = undefined;
    }
    
    public selectCounter(event){
      this.counterId = event.value.id;
    }
    public selectCounterAsal(event){
      this.counterIdOrigin = event.value.id;
    }

}
